import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppCalendarIcon = (props: Props) => {
  const { className, ...rest } = props;
  return <CalendarDaysIcon {...rest} className={className} />;
};
export default withIconSize(AppCalendarIcon);
